import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { BehaviorSubject, filter, map } from 'rxjs'

import { environment } from '../../../environments/environment'
import { BalanceData } from '../components/header/types/balance-data.type'
import { ApiResponse } from '../types/response.type'
import { HelperService } from './helper.service'
import { MarketService } from './market.service'

const API_URL = environment.apiUrl

@Injectable({
	providedIn: 'root',
})
export class BalanceService {
	balanceData$: BehaviorSubject<BalanceData | null> = new BehaviorSubject<BalanceData | null>(null) // The balance data to be shown on the header

	casinoBalanceData$: BehaviorSubject<BalanceData | null> = new BehaviorSubject<BalanceData | null>(null) // Casino wallet balance

	isExposureFromWebSocket$ = new BehaviorSubject<boolean>(false)

	readonly walletUpdateSequence$ = new BehaviorSubject<number>(0)

	isFetchingBalance = false

	firstLoad = true

	constructor(
		private readonly httpClient: HttpClient,
		private readonly helperService: HelperService,
		private readonly marketService: MarketService,
	) {}

	/**
	 * Get the balance of the logged-in user
	 */
	getBalance() {
		const appFromStorage = this.helperService.getUserData()

		if (appFromStorage) {
			// Get the user's ID from local storage
			const userId = appFromStorage?.user_fields?.ID
			this.httpClient
				.get<ApiResponse<BalanceData[]>>(`${API_URL}/user/wallets`, {
					params: {
						session_id: userId,
					},
				})
				.subscribe({
					next: ({ result }) => {
						const exchangeWallet = result.find((balance) => balance.IS_FALLBACK === true)
						const casinoWallet = result.find((balance) => balance.IS_FALLBACK === false)

						if (exchangeWallet) {
							this.balanceData$.next(exchangeWallet)
							this.helperService.setWalletId(exchangeWallet.ID.toString())

							if (this.firstLoad) {
								this.firstLoad = false
								this.prepareCurrency(exchangeWallet.CURRENCY_CODE)
							}
						}

						if (casinoWallet) {
							this.casinoBalanceData$.next(casinoWallet)
						} else {
							this.casinoBalanceData$.next(null)
						}
					},
				})
		}
	}

	prepareCurrency(currencyCode: string) {
		this.marketService
			.getCurrencyRate(currencyCode)
			.pipe(
				map((rateData) => rateData?.result),
				filter(Boolean),
			)
			.subscribe({
				next: (rateDataResult) => {
					this.helperService.setRate(rateDataResult[0].GET_EXCHANGE_RATE ?? '1')
				},
			})
	}

	refreshExposure(walletId: string) {
		return this.httpClient.get(`${API_URL}/api/refresh_exposure/${walletId}`)
	}
}
